import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListadoLogIntegracionSoflexComponent } from './listado-log-integracion-soflex/listado-log-integracion-soflex.component';

const routes: Routes = [
  { path: '', component: ListadoLogIntegracionSoflexComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LogIntegracionSoflexRoutingModule {}
